import { useRef, useState } from "react";
import { toast } from "sonner";
import { ScanText, Loader2 } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Button } from "./ui/button";

export const InvoiceScanButton = ({ onExtracted }) => {
  const { t } = useI18n();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) return toast.error(t("fileTooLarge"));
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/invoices/extract", fd, { timeout: 180000 });
      onExtracted(data);
      toast.success(t("invoiceRead").replace("{n}", data.parts.length));
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
    if (input.current) input.current.value = "";
  };

  return (
    <div className="rounded-lg border-2 border-dashed border-[#F5BE25] bg-amber-50/60 p-3 flex flex-wrap items-center gap-3" data-testid="invoice-scan">
      <input ref={input} type="file" accept="image/*,.pdf" className="hidden" data-testid="invoice-file-input" onChange={(e) => pick(e.target.files[0])} />
      <Button type="button" disabled={busy} data-testid="invoice-scan-btn" className="bg-[#F5BE25] hover:bg-[#E5AC12] text-[#3E3E40]" onClick={() => input.current?.click()}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ScanText className="w-4 h-4" />}
        {busy ? t("readingInvoice") : t("scanInvoice")}
      </Button>
      <p className="text-xs text-slate-600 flex-1 min-w-[180px]">{t("scanInvoiceHint")}</p>
    </div>
  );
};
